module.exports = "/_next/static/images/d6df776ad1532c091af7a57374bba2ae-offer.png.webp";